export const devopsProjects = [
  {
    id: 0,
    title: "CI/CD Pipeline Implementation: Django Application Deployment",
    date: "2026",
    description:
      "Implemented a fully automated CI/CD pipeline for a Dockerized Django application using Jenkins on AWS EC2. GitHub webhooks trigger builds, images are rebuilt, old containers are replaced, and the application is redeployed with environment-based configuration.",
    image: "/jenkins/1.png",
    images: ["/jenkins/1.png", "/jenkins/2.png"],
    tags: [
      "Jenkins",
      "CI/CD",
      "Automation",
      "Docker",
      "AWS",
      "EC2",
      "Django",
      "Webhooks",
    ],
    category: "jenkins",
    github: "",
    webapp: "",
  },
  {
    id: 1,
    title: "Mastering Container Orchestration with Docker & AWS ECS",
    date: "2026",
    description:
      "Deployed a scalable Node.js application using optimized multi-stage Docker builds, pushed images to AWS ECR, and orchestrated services on AWS ECS with rolling deployments, health checks, and auto-scaling policies based on CPU utilization.",
    image: "/aws-ecs/1.png",
    images: [
      "/aws-ecs/1.png",
      "/aws-ecs/2.png",
      "/aws-ecs/3.png",
      "/aws-ecs/4.png",
      "/aws-ecs/5.png",
    ],
    tags: [
      "Docker",
      "Containers",
      "AWS",
      "ECS",
      "ECR",
      "Auto Scaling",
      "Rolling Updates",
      "Node.js",
    ],
    category: "aws-ecs",
    github: "",
    webapp: "",
  },
  {
    id: 2,
    title: "Deploying a Node.js Microservice to AWS EC2 with CI/CD (GitHub Actions)",
    date: "2026",
    description:
      "Automated deployment of a Node.js microservice using GitHub Actions with a self-hosted runner on AWS EC2. The workflow deploys via scripted updates managed by PM2, while Nginx acts as a reverse proxy to serve production traffic.",
    image: "/aws-ec2/1.png",
    images: [
      "/aws-ec2/1.png",
      "/aws-ec2/2.png",
      "/aws-ec2/3.png",
      "/aws-ec2/4.png",
    ],
    tags: [
      "GitHub Actions",
      "CI/CD",
      "AWS",
      "EC2",
      "Self-Hosted Runner",
      "PM2",
      "Nginx",
      "Node.js",
    ],
    category: "aws-ec2",
    github: "",
    webapp: "",
  },
];
